import { useSelector } from 'react-redux';
import { selectCustomizedReportSummarySections } from '../../selectors';

export const useCustomizedReportSection = () => {
  return useSelector(selectCustomizedReportSummarySections);
};
